import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, message, notification } from "antd";
import config from "../../config";
import serviceProfile from "../../services/profile";
import { removeStorageWhenLogout } from "../../config/helper";

const ModalRemoveAccount = ({ openModal, onClose = () => {} }) => {
	const navigate = useNavigate();

	const handleRemoveAccount = async () => {
		try {
			const response = await serviceProfile.deleteAccount();
			if (response.httpStatus === 200) {
				notification.success({ message: "Your account has been deleted." });
				setTimeout(() => {
					removeStorageWhenLogout();
					navigate("/signin");
				}, config.timeout);
			}
			if (response.httpStatus === 401) {
				notification.error({ message: "Unauthorize!" });
				removeStorageWhenLogout();
				setTimeout(() => {
					navigate("/signin");
				}, config.timeout);
			}
			if (response.httpStatus === 500) {
				message.error(
					"Something wrong, please try again in few minutes."
				);
			}
		} catch (error) {
			message.error("Something wrong, please try again in few minutes.");
		}
	};

	return (
		<Modal
			title="Remove My Account"
			className="confirm-modal"
			width="325px"
			open={openModal}
			onCancel={() => {
				onClose({
					popupShow: true,
					removeAvatarShow: false,
				});
			}}
			footer={[
				<Button
					key="remove"
					type="link"
					className="ant-btn-remove"
					onClick={handleRemoveAccount}
				>
					Yes, remove my account
				</Button>,
				<Button
					key="cancel"
					className="ant-btn-cancel"
					onClick={() => {
						onClose({
							popupShow: true,
							removeAvatarShow: false,
						});
					}}
				>
					No
				</Button>,
			]}
			destroyOnClose
		>
			<p>
				Please note that all of your user data, including persona and
				chat conversations, will be permanently deleted.
			</p>
			<p>
				If you only wish to clear your chat history, please visit your
				Profile and select "Clear Chat Conversation."
			</p>
			<p>Are you certain about this decision?</p>
		</Modal>
	);
};

export default ModalRemoveAccount;
